module.exports = __webpack_public_path__ + "static/media/v23.8d2b1121.mp4";